import React, { useState, useRef, createContext, useContext } from 'react';
export type AssociateStatus = 'idle' | 'requesting' | 'confirmed';
type AssociateStatusContextValue = {
  status: AssociateStatus;
  request: () => void;
  reset: () => void;
};
const AssociateStatusContext = createContext<AssociateStatusContextValue | undefined>(undefined);
const REQUESTING_DURATION_MS = 12000;
export function AssociateStatusProvider({
  children
}: {
  children: ReactNode;
}) {
  const [status, setStatus] = useState<AssociateStatus>('idle');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const request = () => {
    if (status !== 'idle') return;
    setStatus('requesting');
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setStatus('confirmed');
    }, REQUESTING_DURATION_MS);
  };
  const reset = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setStatus('idle');
  };
  return <AssociateStatusContext.Provider value={{
    status,
    request,
    reset
  }} data-id="element-28">
      {children}
    </AssociateStatusContext.Provider>;
}
export function useAssociateStatus() {
  const ctx = useContext(AssociateStatusContext);
  if (!ctx) throw new Error('useAssociateStatus must be used inside AssociateStatusProvider');
  return ctx;
}